export const NEWSLETTER_DISCOUNT_CODE = "KITCHENNOTE10";
export const NEWSLETTER_DISCOUNT_PERCENT = 10;
export const NEWSLETTER_PROMO_ID = "newsletter-welcome";
